import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Get all startups with optional filters
export const getStartups = async (params = {}) => {
  const { category, sort, limit, skip, continent, country, city, search } = params;
  const queryParams = new URLSearchParams();
  
  if (category && category !== 'all') queryParams.append('category', category);
  if (sort) queryParams.append('sort', sort);
  if (limit) queryParams.append('limit', limit);
  if (skip) queryParams.append('skip', skip);
  if (continent && continent !== 'All') queryParams.append('continent', continent);
  if (country) queryParams.append('country', country);
  if (city) queryParams.append('city', city);
  if (search) queryParams.append('search', search);
  
  const response = await axios.get(`${API}/startups?${queryParams.toString()}`);
  return response.data;
};

// Get startup count
export const getStartupsCount = async (params = {}) => {
  const { category, continent, country, city } = params;
  const queryParams = new URLSearchParams();
  
  if (category && category !== 'all') queryParams.append('category', category);
  if (continent && continent !== 'All') queryParams.append('continent', continent);
  if (country) queryParams.append('country', country);
  if (city) queryParams.append('city', city);
  
  const response = await axios.get(`${API}/startups/count?${queryParams.toString()}`);
  return response.data.count;
};

// Get single startup by slug
export const getStartupBySlug = async (slug) => {
  const response = await axios.get(`${API}/startups/${slug}`);
  return response.data;
};

// Create new startup
export const createStartup = async (data) => {
  const response = await axios.post(`${API}/startups`, data);
  return response.data;
};

// Upvote a startup
export const upvoteStartup = async (startupId) => {
  const response = await axios.post(`${API}/startups/${startupId}/upvote`);
  return response.data;
};

// Downvote a startup (for toggle)
export const downvoteStartup = async (startupId) => {
  const response = await axios.post(`${API}/startups/${startupId}/downvote`);
  return response.data;
};

// Get categories
export const getCategories = async () => {
  const response = await axios.get(`${API}/categories`);
  return response.data;
};

// Get locations (countries, cities, continents)
export const getLocations = async () => {
  const response = await axios.get(`${API}/locations`);
  return response.data;
};

// Get continents list
export const getContinents = async () => {
  const response = await axios.get(`${API}/continents`);
  return response.data;
};

// Update a startup
export const updateStartup = async (startupId, data) => {
  const response = await axios.put(`${API}/startups/${startupId}`, data);
  return response.data;
};

// Delete a startup
export const deleteStartup = async (startupId) => {
  const response = await axios.delete(`${API}/startups/${startupId}`);
  return response.data;
};
